export interface TranslationItem {
  text: string;
  locale: string;
  keyId: string;
}

export const initialTranslationsState: TranslationItem[] = [
  { locale: 'fi_FI', keyId: '', text: '' },
  { locale: 'en_EN', keyId: '', text: '' },
  { locale: 'ru_RU', keyId: '', text: '' },
];
